import StatsBox from "./StatsPage/StatsBox.js";
import ResultInfoText from "./ResultsTable/ResultInfoText.js";
import renderSearchResults from "../api/renderSearchResults.js";
import { useState } from "react";
import { useEffect } from "react";
import SmallLoading from "./smallLoading.js";

function EnzymeDisplayBox({ reactionsDataByEnzymes, setMechBody, navigateToRecord, isQuickSearch = true, interactiveSearch = () => {}, startingDisplay = 5, displayStep = 5, taxonomyLinks = true  }) {

    const [displayNumber, setDisplayNumber] = useState(startingDisplay);
    const [reactionsBody, setReactionsBody] = useState(null);
    const [loading, setLoading] = useState(true);

    const handleLoadMore = () => {
      setLoading(true);
      setDisplayNumber(displayNumber + displayStep);
      const renderedReactions = renderSearchResults({table: reactionsDataByEnzymes.slice(0, displayNumber + displayStep), setMechBody, isQuickSearch: isQuickSearch, interactiveSearch:interactiveSearch, dataProcessed: true, navigateToRecord: navigateToRecord, taxonomyLinks: taxonomyLinks});
      setReactionsBody(renderedReactions);
      setLoading(false);
    };

    useEffect(() => {
      setLoading(true);
      const renderedReactions = renderSearchResults({table: reactionsDataByEnzymes.slice(0, startingDisplay), setMechBody, isQuickSearch: isQuickSearch, interactiveSearch:interactiveSearch, dataProcessed: true, navigateToRecord: navigateToRecord, taxonomyLinks: taxonomyLinks});
      setReactionsBody(renderedReactions);
      setLoading(false);
    }, []);

  return (
    <>
  {loading ? (
    <SmallLoading />
    ) : (
    <>
      {reactionsBody}

      {displayNumber < reactionsDataByEnzymes.length && (
        <>
          <button className="basic-button" onClick={handleLoadMore}>
            Show more
          </button>

          <ResultInfoText
            text={`Showing ${displayNumber} of ${reactionsDataByEnzymes.length} enzymes`}
            row={1}
          />
        </>
      )}
    </>
  )}
</>

  )

}

export default EnzymeDisplayBox;